export { PredictionConfigsPage } from './PredictionConfigsPage'
export { rolesReducer } from './reducers'
export *  from './actions' 


// WEBPACK FOOTER //
// ./src/App/Admin/PredictionConfigs/index.js